import { useTranslation } from 'react-i18next'
import { useIsMobile } from '../../hooks/useIsMobile'
import { TextParser } from '../TextParser'
import './IntroStory.css'

export const IntroStory = () => {
    const isMobile = useIsMobile()
    const { t } = useTranslation()
    const story = t('story', { returnObjects: true })
    let cardIndex = 0

    return (
        <div className='page-container'>
            <h2 className='story-of-fire-title fire-title'>{story.storyOfFire}</h2>
            <div className='intro-story-title'>
                <h3>{t('story.intro')}</h3>
            </div>

            <div className='page-content-container'>
                {story.chapters.map((chapter, chapterIdx) => (
                    <div key={chapterIdx}>
                        <div className='chapter-title-bar'>
                            {chapter.title}
                        </div>
                        {chapter.sections.map((section, sectionIdx) => {
                            const side = !isMobile ? (cardIndex % 2 === 0 ? 'left' : 'right') : ''
                            cardIndex++
                            return (
                                <div
                                    key={sectionIdx}
                                    className={`page-item ${side}`}>
                                    <div className='page-content'>
                                        {section.paragraphs.map((paragraph, pIdx) => (
                                            <div key={pIdx} className='text-container'>
                                                <TextParser text={paragraph} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ))}
            </div>
        </div>
    )
}
